const normaliseOrgNumber = (value: string) => value.replace(/\D/g, "");

export const matchesByName = (query: string, name: string) => {
	const trimmedQuery = query.trim();
	if (trimmedQuery === "") {
		return true;
	}

	const nameParts = name.split(/\s+/).filter(Boolean);
	const queryParts = trimmedQuery.split(/\s+/).filter(Boolean);
	return queryParts.every((queryPart) => {
		return nameParts.some((part) => {
			return part.toLocaleLowerCase().includes(queryPart.toLocaleLowerCase());
		});
	});
};

export const matchesByOrgNumber = (
	query: string,
	organisationNumber: string | null | undefined,
) => {
	const normalisedQuery = normaliseOrgNumber(query);
	if (normalisedQuery === "") {
		return true;
	}
	if (!organisationNumber) {
		return false;
	}
	return normaliseOrgNumber(organisationNumber).includes(normalisedQuery);
};
